import { Flex } from "@instructure/ui-flex";
import Skeleton from "react-loading-skeleton";
import { auth } from "../../../utils/auth";

const RaterSkeleton = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: auth ? "calc(100vh - 3rem)" : "calc(100vh - 3rem - 3.5rem)",
      }}
    >
      <div style={{ margin: "0 0 0.75rem 0" }}>
        <Flex justifyItems="space-between" wrap="wrap">
          <Flex.Item>
            <Skeleton style={{ height: 30, borderRadius: 5, width: 500 }} />
          </Flex.Item>
          <Flex.Item>
            <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
          </Flex.Item>
        </Flex>
      </div>
      <Flex margin="0 0 small 0" gap="small" wrap="wrap">
        <Flex.Item shouldGrow>
          <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
        </Flex.Item>
        <Flex.Item>
          <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
        </Flex.Item>
        <Flex.Item>
          <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
        </Flex.Item>
      </Flex>
      <Flex gap="small" margin="0 0 small 0" wrap="wrap" justifyItems="end">
        <Flex.Item align="end">
          <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
        </Flex.Item>
        <Flex.Item>
          <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
        </Flex.Item>
        <Flex.Item width="100%">
          <Flex gap="small" wrap="wrap">
            <Flex.Item shouldGrow>
              <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
            </Flex.Item>
            <Flex.Item>
              <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
            </Flex.Item>
            <Flex.Item>
              <Skeleton style={{ height: 30, borderRadius: 5, width: 250 }} />
            </Flex.Item>
          </Flex>
        </Flex.Item>
      </Flex>
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          flexShrink: 1,
          overflowY: "hidden",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            width: "50%",
            paddingRight: "1.5rem",
            borderRight: "0.0625rem solid #C7CDD1",
          }}
        >
          <Skeleton style={{ height: "100%", borderRadius: 5 }} />
        </div>
        <div
          style={{
            width: "50%",
            overflowY: "auto",
            overflowX: "hidden",
            paddingLeft: "1.5rem",
          }}
        >
          <Skeleton style={{ height: "50%", borderRadius: 5 }} />
          <Flex
            justifyItems="end"
            alignItems="start"
            margin="small 0"
            gap="small"
            wrap="wrap"
          >
            <Flex.Item>
              <Flex justifyItems="end" gap="small" wrap="wrap">
                <Flex.Item>
                  <Skeleton
                    style={{ height: 30, borderRadius: 5, width: 100 }}
                  />
                </Flex.Item>
                <Flex.Item>
                  <Skeleton
                    style={{ height: 30, borderRadius: 5, width: 100 }}
                  />
                </Flex.Item>
                <Flex.Item>
                  <Skeleton
                    style={{ height: 30, borderRadius: 5, width: 100 }}
                  />
                </Flex.Item>
                <Flex.Item>
                  <Skeleton
                    style={{ height: 30, borderRadius: 5, width: 100 }}
                  />
                </Flex.Item>
              </Flex>
            </Flex.Item>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default RaterSkeleton;
